/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { BusinessObjectDefinitionTag } from '../model/businessObjectDefinitionTag';
import { BusinessObjectDefinitionTagCreateRequest } from '../model/businessObjectDefinitionTagCreateRequest';
import { BusinessObjectDefinitionTagKeys } from '../model/businessObjectDefinitionTagKeys';
import { ErrorInformation } from '../model/errorInformation';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class BusinessObjectDefinitionTagService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createBusinessObjectDefinitionTag
     * Creates a new business object definition tag. &lt;p&gt;Requires WRITE or WRITE_DESCRIPTIVE_CONTENT permission on namespace&lt;/p&gt;
     * @param businessObjectDefinitionTagCreateRequest the information needed to create a business object definition tag
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionTagCreateBusinessObjectDefinitionTag(businessObjectDefinitionTagCreateRequest: BusinessObjectDefinitionTagCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinitionTag>;
    public businessObjectDefinitionTagCreateBusinessObjectDefinitionTag(businessObjectDefinitionTagCreateRequest: BusinessObjectDefinitionTagCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinitionTag>>;
    public businessObjectDefinitionTagCreateBusinessObjectDefinitionTag(businessObjectDefinitionTagCreateRequest: BusinessObjectDefinitionTagCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinitionTag>>;
    public businessObjectDefinitionTagCreateBusinessObjectDefinitionTag(businessObjectDefinitionTagCreateRequest: BusinessObjectDefinitionTagCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (businessObjectDefinitionTagCreateRequest === null || businessObjectDefinitionTagCreateRequest === undefined) {
            throw new Error('Required parameter businessObjectDefinitionTagCreateRequest was null or undefined when calling businessObjectDefinitionTagCreateBusinessObjectDefinitionTag.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<BusinessObjectDefinitionTag>(`${this.configuration.basePath}/businessObjectDefinitionTags`,
            businessObjectDefinitionTagCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteBusinessObjectDefinitionTag
     * Deletes an existing business object definition tag. &lt;p&gt;Requires WRITE or WRITE_DESCRIPTIVE_CONTENT permission on namespace&lt;/p&gt;
     * @param namespace the namespace of the business object definition
     * @param businessObjectDefinitionName the name of the business object definition
     * @param tagTypeCode the tag type reference code of the tag
     * @param tagCode the tag reference code of the tag
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionTagDeleteBusinessObjectDefinitionTag(namespace: string, businessObjectDefinitionName: string, tagTypeCode: string, tagCode: string, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinitionTag>;
    public businessObjectDefinitionTagDeleteBusinessObjectDefinitionTag(namespace: string, businessObjectDefinitionName: string, tagTypeCode: string, tagCode: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinitionTag>>;
    public businessObjectDefinitionTagDeleteBusinessObjectDefinitionTag(namespace: string, businessObjectDefinitionName: string, tagTypeCode: string, tagCode: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinitionTag>>;
    public businessObjectDefinitionTagDeleteBusinessObjectDefinitionTag(namespace: string, businessObjectDefinitionName: string, tagTypeCode: string, tagCode: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectDefinitionTagDeleteBusinessObjectDefinitionTag.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectDefinitionTagDeleteBusinessObjectDefinitionTag.');
        }
        if (tagTypeCode === null || tagTypeCode === undefined) {
            throw new Error('Required parameter tagTypeCode was null or undefined when calling businessObjectDefinitionTagDeleteBusinessObjectDefinitionTag.');
        }
        if (tagCode === null || tagCode === undefined) {
            throw new Error('Required parameter tagCode was null or undefined when calling businessObjectDefinitionTagDeleteBusinessObjectDefinitionTag.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<BusinessObjectDefinitionTag>(`${this.configuration.basePath}/businessObjectDefinitionTags/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/tagTypes/${encodeURIComponent(String(tagTypeCode))}/tagCodes/${encodeURIComponent(String(tagCode))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getBusinessObjectDefinitionTagsByBusinessObjectDefinition
     * Gets a list of keys for all existing business object definition tags that are associated with the specified business object definition.
     * @param namespace the namespace of the business object definition
     * @param businessObjectDefinitionName the name of the business object definition
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionTagGetBusinessObjectDefinitionTagsByBusinessObjectDefinition(namespace: string, businessObjectDefinitionName: string, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinitionTagKeys>;
    public businessObjectDefinitionTagGetBusinessObjectDefinitionTagsByBusinessObjectDefinition(namespace: string, businessObjectDefinitionName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinitionTagKeys>>;
    public businessObjectDefinitionTagGetBusinessObjectDefinitionTagsByBusinessObjectDefinition(namespace: string, businessObjectDefinitionName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinitionTagKeys>>;
    public businessObjectDefinitionTagGetBusinessObjectDefinitionTagsByBusinessObjectDefinition(namespace: string, businessObjectDefinitionName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectDefinitionTagGetBusinessObjectDefinitionTagsByBusinessObjectDefinition.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectDefinitionTagGetBusinessObjectDefinitionTagsByBusinessObjectDefinition.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<BusinessObjectDefinitionTagKeys>(`${this.configuration.basePath}/businessObjectDefinitionTags/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getBusinessObjectDefinitionTagsByTag
     * Gets a list of keys for all existing business object definition tags that are associated with the specified tag.
     * @param tagTypeCode the tag type reference code
     * @param tagCode the tag reference code
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionTagGetBusinessObjectDefinitionTagsByTag(tagTypeCode: string, tagCode: string, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinitionTagKeys>;
    public businessObjectDefinitionTagGetBusinessObjectDefinitionTagsByTag(tagTypeCode: string, tagCode: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinitionTagKeys>>;
    public businessObjectDefinitionTagGetBusinessObjectDefinitionTagsByTag(tagTypeCode: string, tagCode: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinitionTagKeys>>;
    public businessObjectDefinitionTagGetBusinessObjectDefinitionTagsByTag(tagTypeCode: string, tagCode: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (tagTypeCode === null || tagTypeCode === undefined) {
            throw new Error('Required parameter tagTypeCode was null or undefined when calling businessObjectDefinitionTagGetBusinessObjectDefinitionTagsByTag.');
        }
        if (tagCode === null || tagCode === undefined) {
            throw new Error('Required parameter tagCode was null or undefined when calling businessObjectDefinitionTagGetBusinessObjectDefinitionTagsByTag.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<BusinessObjectDefinitionTagKeys>(`${this.configuration.basePath}/businessObjectDefinitionTags/tagTypes/${encodeURIComponent(String(tagTypeCode))}/tagCodes/${encodeURIComponent(String(tagCode))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
